import {
  REQUEST_KEYWORD_GRANTS,
  RESPONSE_KEYWORD_GRANTS,
  FAILURE_KEYWORD_GRANTS,
  REQUEST_KEYWORD_GRANTS_WITH_FILTER,
  GRANT_SORT_UPDATE
} from "../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  results: [],
  error: false,
  isInitialScreen: true,
  total: 0,
  totalFundingOrgs: 0,
  totalRecOrgs: 0,
  totalGrants: 0,
  statusCode: 0,
  totalLast3Years: 0,
  country: [],
  year: "All",
  isFilterActive: false,
  activePage: 1,
  filters: {
    active: "false",
    year: "",
    experts: [],
    university: [],
    fund_org: [],
    rec_org: [],
    activeSortItem: { value: "recipient", label: "TOTAL RECIPIENTS" }
  }
};

const setFetching = (state, action) => {
  let activePage = action.payload.activePage || 1;
  let filters = action.payload.filters || {
    year: "",
    experts: [],
    university: [],
    fund_org: [],
    rec_org: [],
    activeSortItem: { value: "amount", label: "GRANT AMOUNT" }
  };
  return {
    ...state,
    isFetching: true,
    results: [],
    keyword: action.payload.keyword,
    isInitialScreen: false,
    totalGrants: 0,
    statusCode: 0,
    country: [],
    filters: filters,
    year: "All",
    isFilterActive: false,
    activePage: activePage,
    size: 10
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    totalGrants: 0
  };
};

const setResults = (state, action) => {
  let results = action.payload.grants || [];
  let totalGrants = action.payload.totalGrants || 0;
  let statusCode = action.payload.statusCode;
  let total = action.payload.total || 0;
  let totalFundingOrgs = action.payload.totalFundingOrgs || 0;
  let totalRecOrgs = action.payload.totalRecOrgs || 0;
  let totalLast3Years = action.payload.totalLast3Years || 0;

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    totalGrants,
    statusCode,
    total,
    totalFundingOrgs,
    totalRecOrgs,
    totalLast3Years
  };
};

const updateGrants = (state, action) => {
  let sortItem = action.payload.results || [];

  return {
    ...state,
    sortItem
  };
};

const setFetchingFilter = (state, action) => {
  return {
    ...state,
    isFetching: true,
    isFilterActive: true,
    country: action.payload.country,
    year: action.payload.year
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_KEYWORD_GRANTS:
      return setFetching(state, action);
      break;

    case RESPONSE_KEYWORD_GRANTS:
      return setResults(state, action);

    case FAILURE_KEYWORD_GRANTS:
      return setFailure(state, action);

    case REQUEST_KEYWORD_GRANTS_WITH_FILTER:
      return setFetchingFilter(state, action);

    case GRANT_SORT_UPDATE:
      return updateGrants(state, action);

    default:
      return state;
      break;
  }
};
